export const TRAILER_RECORDING_MIME_TYPES = [
  "audio/webm;codecs=opus",
  "audio/mp4",
  "audio/ogg;codecs=opus",
  "audio/webm"
]

export function trailerRecordingSupported({ MediaRecorderClass, mediaDevices }) {
  return typeof MediaRecorderClass !== "undefined" &&
    typeof mediaDevices?.getUserMedia === "function"
}

export function preferredTrailerRecordingMimeType(MediaRecorderClass) {
  if (typeof MediaRecorderClass?.isTypeSupported !== "function") return ""
  return TRAILER_RECORDING_MIME_TYPES.find((mimeType) => {
    return MediaRecorderClass.isTypeSupported(mimeType)
  }) || ""
}
